import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/pt-br';

const useStyles = makeStyles(() => ({
  root: {
    color: '#1A1A1A',
    fontSize: '0.82rem',
    fontWeight: 500,
    lineHeight: 1.35,
    margin: 0,
    textAlign: 'left',
    '& strong': {
      fontWeight: 700,
    },
  },
  line: {
    display: 'block',
  },
}));

// Bloco da extração da Loteria Federal que gerou o resultado. Cadastro manual
// no backoffice (federal_draw_label + federal_draw_breakdown); data e número
// sorteado vêm dos campos que a campanha já tem.
export default function FederalDrawInfo({ campaign }) {
  const classes = useStyles();

  if (!campaign?.federal_draw_label) return null;

  moment.locale('pt-br');
  const drawDate = campaign.draw_time ? moment(campaign.draw_time) : null;
  const weekday = drawDate
    ? drawDate.format('dddd').replace(/^./, (c) => c.toUpperCase())
    : null;

  const breakdownLines = (campaign.federal_draw_breakdown || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <Typography className={classes.root} variant="body2" component="div">
      <span className={classes.line}>
        {drawDate && `${weekday} ${drawDate.format('DD/MM/YYYY')} — `}
        Loteria Federal, extração nº <strong>{campaign.federal_draw_label}</strong>
      </span>
      {breakdownLines.map((line, index) => (
        <span className={classes.line} key={index}>{line}</span>
      ))}
      {campaign.drawn_number && (
        <span className={classes.line}>
          Número sorteado = <strong>{campaign.drawn_number}</strong>
        </span>
      )}
    </Typography>
  );
}
